import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P50-E1',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 2,
    exerciseKey: 'img/FriendsPlus/Page50/E1/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page50/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page50/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page50/E1/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E1/4.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E1/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page50/E1/6.jpg' },
      ],



    ]
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P50-E2',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 7,
    exerciseKey: 'img/FriendsPlus/Page50/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page50/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page50/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/4.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page50/E2/5.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page50/E2/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page50/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/8.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/9.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page50/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/11.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page50/E2/12.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/13.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page50/E2/14.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page50/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/16.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/17.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page50/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/19.jpg', input: 5, },
        { url: 'img/FriendsPlus/Page50/E2/20.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/21.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page50/E2/22.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page50/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/24.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/25.jpg', input: 6, },
        { url: 'img/FriendsPlus/Page50/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page50/E2/27.jpg', input: 7, },
        { url: 'img/FriendsPlus/Page50/E2/28.jpg', input: 7, isCorrect: true },
        { url: 'img/FriendsPlus/Page50/E2/29.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page50/E2/30.jpg' },
      ],
    ]
  },


}

export default json;